module.exports = __webpack_public_path__ + "img/hand.c5c4e757.png";